import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import FlightIcon from '@mui/icons-material/Flight';
import TableRow from '@mui/material/TableRow';
import Section from 'components/Section';
import TwoColumn from 'components/TwoColumn';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import PackageEditTransportFlightsRow from 'components/PackageEditTransportFlightsRow';

import { PackageEditTransportFlights_package$key } from '__generated__/PackageEditTransportFlights_package.graphql';
import { PackageEditTransportFlights_data$key } from '__generated__/PackageEditTransportFlights_data.graphql';
import AirportSelect from 'components/AirportSelect';

type Props = {
  package: PackageEditTransportFlights_package$key;
  data: PackageEditTransportFlights_data$key;
};

const PackageEditTransportFlights: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment PackageEditTransportFlights_package on Package {
        dates: tripDates(first: 2147483647) {
          __id
          edges {
            node {
              id
              ...PackageEditTransportFlightsRow_packageDate
            }
          }

          pageInfo {
            ...Table_pageInfo
          }
        }

        ...PackageEditTransportFlightsRow_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageEditTransportFlights_data on Query {
        ...PackageEditTransportFlightsRow_data
        ...AirportSelect_data
      }
    `,
    props.data
  );

  const { dates } = pack;

  return (
    <Section id="flights" title="Skrydžiai">
      <TwoColumn
        sx={{ mb: 2 }}
        left={
          <AirportSelect
            name="defaultDepartureAirport"
            label="Iš kur"
            data={data}
          />
        }
        right={
          <AirportSelect
            name="defaultArrivalAirport"
            label="Į kur"
            data={data}
          />
        }
      />

      <Table
        pageInfo={dates?.pageInfo ?? null}
        icon={<FlightIcon />}
        head={
          <TableRow>
            <TableCell center>Kelionės datos</TableCell>
            <TableCell center>Išvykstantis skrydis</TableCell>
            <TableCell center>Išvykstančio skrydžio nr.</TableCell>
            <TableCell center>Parvykstantis skrydis</TableCell>
            <TableCell center>Parvykstančio skrydžio nr.</TableCell>
            <TableCell center>Persėdimų trukmė</TableCell>
            <TableCell center>Kaina</TableCell>
            <TableCell />
          </TableRow>
        }>
        {dates?.edges?.map(({ node }) => (
          <PackageEditTransportFlightsRow
            key={node.id}
            packageDate={node}
            data={data}
            package={pack}
          />
        ))}
      </Table>
    </Section>
  );
};

export default PackageEditTransportFlights;
